import { on } from '../lib/domUtils'
import { addClass, toggleClass, removeClass } from '../lib/classie'

const onClickCountrySelection = () => {
  const countrySelection = document.querySelector('.country-selection-dropdown')
  const countrySelected = document.querySelector('.dropdown-selected')
  const dropdownLabel = document.querySelector('.dropdown-label')

  if (countrySelection) {
    on(countrySelected, 'click', () => {
      toggleClass(countrySelection, 'is-active')
    })
  }

  on('.country-selection', 'click', e => {
    const { href } = e.currentTarget.dataset
    if (href) {
      dropdownLabel.href = href
      countrySelected.innerText = e.currentTarget.innerText
      removeClass(countrySelection, 'is-active')
    }
  })
}

onClickCountrySelection()
